var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Color_Vertical_White",
    viewBox: "0 0 504 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#005487;}.cls-2{fill:#7ebc42;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.21,242.25h7.31v1.65h-5.44v2.77h5.33v1.65h-5.33v2.96h5.44v1.65h-7.31v-10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.64,242.25h1.87v9.03h4.71v1.65h-6.58v-10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.11,242.25h7.31v1.65h-5.44v2.77h5.33v1.65h-5.33v2.96h5.44v1.65h-7.31v-10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.06,247.6c0-3.28,2.45-5.52,5.52-5.52,2.24,0,3.57,1.12,4.37,2.4l-1.6,.82c-.51-.88-1.54-1.55-2.77-1.55-2.03,0-3.6,1.62-3.6,3.86s1.57,3.86,3.6,3.86c1.23,0,2.26-.66,2.77-1.55l1.6,.82c-.82,1.28-2.13,2.4-4.37,2.4-3.07,0-5.52-2.24-5.52-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.2,243.9h-3.23v-1.65h8.34v1.65h-3.23v9.03h-1.87v-9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.82,248.94h-1.86v3.99h-1.87v-10.68h4.69c2.11,0,3.49,1.38,3.49,3.35s-1.25,2.93-2.53,3.14l2.61,4.19h-2.16l-2.37-3.99Zm.7-5.04h-2.56v3.39h2.56c1.06,0,1.82-.67,1.82-1.7s-.77-1.7-1.82-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M179.31,242.08c3.2,0,5.46,2.34,5.46,5.52s-2.26,5.52-5.46,5.52-5.46-2.34-5.46-5.52,2.26-5.52,5.46-5.52Zm0,1.67c-2.16,0-3.54,1.65-3.54,3.86s1.38,3.86,3.54,3.86,3.54-1.66,3.54-3.86-1.39-3.86-3.54-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.65,245.15v7.78h-1.87v-10.68h1.92l5.46,7.57v-7.57h1.87v10.68h-1.81l-5.57-7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M204.49,242.25h1.87v10.68h-1.87v-10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.36,247.6c0-3.28,2.45-5.52,5.52-5.52,2.24,0,3.57,1.12,4.37,2.4l-1.6,.82c-.51-.88-1.54-1.55-2.77-1.55-2.03,0-3.6,1.62-3.6,3.86s1.57,3.86,3.6,3.86c1.23,0,2.26-.66,2.77-1.55l1.6,.82c-.82,1.28-2.13,2.4-4.37,2.4-3.07,0-5.52-2.24-5.52-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.14,242.25h2.13l3.23,8.64,3.23-8.64h2.13l-4.19,10.68h-2.34l-4.19-10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.89,242.08c3.2,0,5.46,2.34,5.46,5.52s-2.26,5.52-5.46,5.52-5.46-2.34-5.46-5.52,2.26-5.52,5.46-5.52Zm0,1.67c-2.16,0-3.54,1.65-3.54,3.86s1.38,3.86,3.54,3.86,3.54-1.66,3.54-3.86-1.39-3.86-3.54-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.5,243.9h-3.23v-1.65h8.34v1.65h-3.23v9.03h-1.87v-9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.38,242.25h1.87v10.68h-1.87v-10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M283.6,245.15v7.78h-1.87v-10.68h1.92l5.46,7.57v-7.57h1.87v10.68h-1.81l-5.57-7.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.57,242.08c2.08,0,3.44,.99,4.31,2.23l-1.54,.86c-.56-.8-1.57-1.42-2.77-1.42-2.11,0-3.68,1.62-3.68,3.86s1.57,3.87,3.68,3.87c1.09,0,2.05-.51,2.53-.96v-1.66h-3.18v-1.65h5.06v4c-1.06,1.17-2.54,1.94-4.4,1.94-3.09,0-5.6-2.19-5.6-5.54s2.51-5.52,5.6-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.78,249.98c.74,.78,1.89,1.47,3.38,1.47s2.14-.75,2.14-1.46c0-.96-1.14-1.25-2.43-1.58-1.75-.43-3.79-.94-3.79-3.2,0-1.76,1.55-3.12,3.89-3.12,1.67,0,3.01,.53,4,1.49l-1.07,1.39c-.83-.83-1.97-1.22-3.09-1.22s-1.81,.53-1.81,1.33,1.09,1.1,2.35,1.42c1.76,.45,3.86,.99,3.86,3.31,0,1.78-1.25,3.3-4.13,3.3-1.97,0-3.39-.69-4.34-1.7l1.04-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334,248.5l-4.15-6.24h2.15l2.95,4.58,2.91-4.58h2.14l-4.13,6.24v4.43h-1.87v-4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344.4,249.98c.74,.78,1.89,1.47,3.38,1.47s2.14-.75,2.14-1.46c0-.96-1.14-1.25-2.43-1.58-1.75-.43-3.79-.94-3.79-3.2,0-1.76,1.55-3.12,3.89-3.12,1.67,0,3.01,.53,4,1.49l-1.07,1.39c-.83-.83-1.97-1.22-3.09-1.22s-1.81,.53-1.81,1.33,1.09,1.1,2.35,1.42c1.76,.45,3.86,.99,3.86,3.31,0,1.78-1.25,3.3-4.13,3.3-1.97,0-3.39-.69-4.34-1.7l1.04-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.13,243.9h-3.23v-1.65h8.34v1.65h-3.23v9.03h-1.87v-9.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M369.02,242.25h7.31v1.65h-5.44v2.77h5.33v1.65h-5.33v2.96h5.44v1.65h-7.31v-10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.67,244.85l-3.28,8.08h-.8l-3.27-8.08v8.08h-1.87v-10.68h2.64l2.9,7.19,2.91-7.19h2.64v10.68h-1.87v-8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.36,249.98c.74,.78,1.89,1.47,3.38,1.47s2.14-.75,2.14-1.46c0-.96-1.14-1.25-2.43-1.58-1.75-.43-3.79-.94-3.79-3.2,0-1.76,1.55-3.12,3.89-3.12,1.67,0,3.01,.53,4,1.49l-1.07,1.39c-.83-.83-1.97-1.22-3.09-1.22s-1.81,.53-1.81,1.33,1.09,1.1,2.35,1.42c1.76,.45,3.86,.99,3.86,3.31,0,1.78-1.25,3.3-4.13,3.3-1.97,0-3.39-.69-4.34-1.7l1.04-1.44Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.95,183.32h11.21v43.47h-11.21v-43.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.34,208.61c0-3.84-2.02-5.21-5.15-5.21s-4.95,1.63-6.13,3.06v20.33h-10.04v-31.48h10.04v3.84c1.89-2.22,5.6-4.63,10.88-4.63,7.17,0,10.43,4.17,10.43,9.97v22.29h-10.04v-18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.48,215.84c2.35,2.09,7.36,4.17,11.08,4.17,3,0,4.24-.98,4.24-2.35,0-1.63-2.15-2.22-5.41-2.74-5.34-.91-12.9-2.02-12.9-10.04,0-5.54,4.76-10.36,13.49-10.36,5.28,0,9.78,1.69,13.16,4.17l-3.84,6.65c-1.89-1.82-5.47-3.45-9.25-3.45-2.35,0-3.98,.78-3.98,2.15s1.69,1.96,5.02,2.54c5.34,.91,13.29,2.22,13.29,10.56,0,6-5.28,10.43-14.34,10.43-5.6,0-11.4-1.89-14.73-4.82l4.17-6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.96,218.32v-14.27h-5.21v-8.73h5.21v-8.6h9.97v8.6h6.39v8.73h-6.39v11.47c0,1.82,1.04,3.19,2.8,3.19,1.11,0,2.22-.39,2.54-.78l1.96,7.56c-1.24,1.17-3.71,2.09-7.43,2.09-6.39,0-9.84-3.19-9.84-9.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M206.29,223.66c-1.96,2.35-5.73,3.91-9.78,3.91-4.82,0-10.82-3.26-10.82-10.36,0-7.62,6-9.91,10.82-9.91,4.17,0,7.89,1.3,9.78,3.65v-3.98c0-2.74-2.35-4.56-6.39-4.56-3.13,0-6.39,1.17-8.93,3.32l-3.58-6.32c4.04-3.45,9.45-4.89,14.27-4.89,7.56,0,14.66,2.8,14.66,12.58v19.68h-10.04v-3.13Zm0-7.76c-1.04-1.43-3.39-2.22-5.6-2.22-2.67,0-5.02,1.17-5.02,3.65s2.35,3.65,5.02,3.65c2.22,0,4.56-.78,5.6-2.28v-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.21,208.61c0-3.84-2.02-5.21-5.15-5.21s-4.95,1.63-6.13,3.06v20.33h-10.04v-31.48h10.04v3.84c1.89-2.22,5.6-4.63,10.88-4.63,7.17,0,10.43,4.17,10.43,9.97v22.29h-10.04v-18.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.98,218.32v-14.27h-5.21v-8.73h5.21v-8.6h9.97v8.6h6.39v8.73h-6.39v11.47c0,1.82,1.04,3.19,2.8,3.19,1.11,0,2.22-.39,2.54-.78l1.96,7.56c-1.24,1.17-3.71,2.09-7.43,2.09-6.39,0-9.84-3.19-9.84-9.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.63,183.32h31.87v9.45h-20.66v7.23h20.2v9.52h-20.2v7.82h20.66v9.45h-31.87v-43.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.1,183.32h10.04v43.47h-10.04v-43.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.41,194.53c9.32,0,16.1,6.84,16.1,17.53v2.15h-22.42c.59,2.93,3.32,5.6,8.02,5.6,2.8,0,5.93-1.11,7.69-2.67l4.24,6.26c-3.13,2.8-8.34,4.17-13.16,4.17-9.71,0-17.21-6.32-17.21-16.55,0-9.12,6.91-16.49,16.75-16.49Zm-6.45,13.16h12.97c-.26-2.22-1.89-5.41-6.52-5.41-4.37,0-6.06,3.13-6.45,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396.93,194.53c6.78,0,11.01,3,12.9,5.8l-6.52,6.06c-1.24-1.82-3.26-3-5.93-3-4.17,0-7.36,2.87-7.36,7.62s3.19,7.69,7.36,7.69c2.67,0,4.69-1.3,5.93-3.06l6.52,6.13c-1.89,2.74-6.13,5.8-12.9,5.8-9.84,0-17.2-6.65-17.2-16.55s7.36-16.49,17.2-16.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.83,218.32v-14.27h-5.21v-8.73h5.21v-8.6h9.97v8.6h6.39v8.73h-6.39v11.47c0,1.82,1.04,3.19,2.8,3.19,1.11,0,2.22-.39,2.54-.78l1.96,7.56c-1.24,1.17-3.71,2.09-7.43,2.09-6.39,0-9.84-3.19-9.84-9.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M436.16,182.13h-1.87v-.65h4.48v.65h-1.88v5.25h-.73v-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M444.79,182.52l-2.01,4.86h-.3l-2-4.86v4.86h-.73v-5.9h1.05l1.83,4.44,1.84-4.44h1.05v5.9h-.74v-4.86Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.14,120.16h51.18v14.79c0,3.57-2.89,6.46-6.46,6.46h-44.72v-21.25h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 242.14,
    y: 88.74,
    width: 51.18,
    height: 21.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.14,57.33h44.72c3.57,0,6.46,2.89,6.46,6.46v14.79h-51.18v-21.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.41,104.48h46.26v21.25h-52.72v-14.79c0-3.57,2.89-6.46,6.46-6.46Z",
    transform: "translate(106.21 336.41) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 210.68,
    y: 57.33,
    width: 21.25,
    height: 21.25,
    rx: 6.46,
    ry: 6.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.64,159.02h-75.28c-12.13,0-21.99-9.87-21.99-21.99V61.74c0-12.13,9.87-21.99,21.99-21.99h75.28c12.13,0,21.99,9.87,21.99,21.99v75.28c0,12.13-9.87,21.99-21.99,21.99ZM214.36,47.08c-8.09,0-14.67,6.58-14.67,14.67v75.28c0,8.09,6.58,14.67,14.67,14.67h75.28c8.09,0,14.67-6.58,14.67-14.67V61.74c0-8.09-6.58-14.67-14.67-14.67h-75.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.0dd32fe613103a239b86148a37ed6d98.svg";
export { ForwardRef as ReactComponent };